import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import ApiService from "../../services/ApiService";
import { SPONSOR_VALUE_BREAKDOWN } from "../keys";
import { format } from "date-fns";

const useSponsorValueBreakdown = ({ mode = "channel", drilldown = null }) => {
  const tenant = useSelector((state) => state.auth.tenant);
  const date = useSelector((state) => state.date);

  const { startDate, endDate } = date;
  const enabled = !!(date.startDate && date.endDate);
  let since;
  let until;
  if (enabled) {
    since = format(date.startDate, "yyyy-MM-dd");
    until = format(date.endDate, "yyyy-MM-dd");
  }

  return useQuery({
    queryKey: [SPONSOR_VALUE_BREAKDOWN, tenant.id, mode, drilldown, startDate, endDate],
    queryFn: () => ApiService.getSponsorValueBreakdown(since, until, mode, drilldown),
    select: (data) => data.data,
    enabled,
    placeholderData: {
      data: {
        items: [],
        total: 0,
        mode: mode,
      }
    },
  });
};

export default useSponsorValueBreakdown;
